import apiService from '../apiService';

export const addTagTypes = ['Documents_List', 'Addresses_List'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getDocumentsList: build.query({
				query: () => ({
					url: `document`
				}),
				providesTags: ['Documents_List']
			}),
			uploadDocument: build.mutation({
				query: ({ payload }) => {
					// If payload is FormData, send it directly without wrapping
					if (payload instanceof FormData) {
						return {
							url: 'document/store',
							method: 'POST',
							body: payload
						};
					}

					// Otherwise, wrap in payload object
					return {
						url: 'document/store',
						method: 'POST',
						body: { payload }
					};
				},
				invalidatesTags: ['Documents_List', 'Addresses_List']
			}),
			getDocumentDetails: build.query({
				query: (documentId) => ({
					url: `document/show/${documentId}`
				}),
				providesTags: ['Documents_List']
			}),
			deleteDocument: build.mutation({
				query: ({ documentId }) => ({
					url: `document/delete/${documentId}`,
					method: 'DELETE'
				}),
				invalidatesTags: ['Documents_List', 'Addresses_List']
			}),
			retryDocument: build.mutation({
				query: ({ documentId }) => ({
					url: `document/retry/${documentId}`,
					method: 'POST'
				}),
				invalidatesTags: ['Documents_List']
			})
		})
	});

export const {
	useGetDocumentsListQuery,
	useUploadDocumentMutation,
	useGetDocumentDetailsQuery,
	useDeleteDocumentMutation,
	useRetryDocumentMutation
} = applicationsApi;
